(function (scope) {
  'use strict';
  const normalize = value => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
  const available = product => Array.isArray(product.variants) && product.variants.some(variant => variant.available === true);
  function match(product, characters) {
    const tags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',').map(tag => tag.trim());
    const ids = tags.filter(tag => tag.startsWith('db-character:')).map(tag => tag.slice(13));
    if (ids.length) return characters.filter(character => ids.includes(character.id)).map(character => character.id);
    const title = ' ' + normalize(product.title) + ' ';
    if (/\b(booster|display|starter deck|playmat|sleeves)\b/.test(title)) return [];
    const exclusions = {
      'son-gohan': /\b(grandpa|grandfather) (son )?gohan\b|\bgroßvater (son )?gohan\b/,
      'cell': /\bcell (max|jr|junior|juniors)\b/,
      'android-17': /\bsuper (android |c )?17\b/,
      'shin': /\bsupreme kai of time\b|\bold supreme kai\b/
    };
    const hits = [];
    for (const character of characters) {
      if (exclusions[character.id]?.test(title)) continue;
      for (const alias of [character.name, ...character.aliases]) {
        const key = normalize(alias);
        if (!key) continue;
        const start = title.indexOf(' ' + key + ' ');
        if (start !== -1) hits.push({ id: character.id, start, end: start + key.length + 2, length: key.length });
      }
    }
    const specific = hits.filter(hit => !hits.some(other => other.id !== hit.id && other.start <= hit.start && other.end >= hit.end && other.length > hit.length));
    specific.sort((a, b) => a.start - b.start || b.length - a.length);
    return specific.length ? [specific[0].id] : [];
  }
  function indexProducts(products, characters) {
    const all = new Map(characters.map(character => [character.id, []]));
    const found = new Map(characters.map(character => [character.id, []]));
    const unmatched = [];
    const seen = new Set();
    for (const product of products) {
      const identity = product.id || product.handle;
      if (seen.has(identity)) continue;
      seen.add(identity);
      const ids = match(product, characters);
      if (!ids.length) unmatched.push(product);
      for (const id of ids) {
        all.get(id).push(product);
        if (available(product)) found.get(id).push(product);
      }
    }
    return { all, found, unmatched };
  }
  const api = { normalize, available, match, indexProducts };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else scope.CHWDragonCore = api;
})(typeof window === 'undefined' ? {} : window);
